import { app } from '../../../../../app';
import { Controller } from './import-csv.controller';

app.component('companySharingCenterImportCsv', {
	bindings: {
        companyId: '<',
        labels$: '<',
        importFileTypes: '<'
    },
    controller: Controller,
    templateUrl: require('./import-csv.html'),
});


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/import-csv/import-csv.component.js